<template>
  <div class="example-avatar">
    <div class="sa-row sa-d-f-a-center">
      <div
        class="sa-col-xs12 sa-col-sm8 sa-col-md8 sa-col-lg8 sa-d-f-a-center sa-profilecenter"
      >
        <div class="sa-avtar-bg">
          <div class="sa-avtar sa-avtar-lg">
            <input
              type="file"
              ref="file"
              @change="onFileChange"
              @input-file="inputFile"
              class="sa-d-none"
              id="avtar"
              name="avtar"
              :data="{ uploadtype: 'profilepic' }"
              post-action="https://imgpre.litedev.com/upload"
            />
            <button
              type="button"
              @click="selectFile"
              class="sa-up-btn sa-h-xs"
            ></button>
            <img :src="file ? file : unknownImg" alt="" />
          </div>
          <img
            src="../../assets/img/loader.svg"
            alt="loader"
            class="sa-avtar-loader"
            v-if="loader"
          />
          <span
            class="sa-avtar-ico sa-avtar-ico-blu"
            @click="selectFile"
            :class="pedit ? '' : 'sa-d-none'"
          >
            <i class="icon-pencil"></i>
          </span>
          <!-- <button type="button" @click="removeFile" v-if="file">Remove Image</button> -->
        </div>
        <h6 class="sa-h-xs">
          {{ user.title }} {{ user.fn }} {{ user.ln
          }}<span class="sa-font-normal sa-f-size13 sa-d-block">{{
            user.email
          }}</span>
        </h6>
      </div>
      <div
        class="sa-col-xs12 sa-col-sm4 sa-col-md4 sa-col-lg4 sa-d-f-a-center sa-d-f-end"
      >
        <svg class="donut sa-h-xs" viewBox="1.6 1.6 16.8 16.8">
          <circle class="donutbg" cx="10" cy="10" r="8"></circle>
          <circle
            class="stroke"
            :style="{ strokeDashoffset: MM }"
            cx="10"
            cy="10"
            r="8"
          ></circle>
          <text x="62%" y="70%">{{ user.profile_complete }}%</text>
        </svg>
        <button
          class="sa-btn sa-btn-default sa-edit-btn"
          @click="pedit = !pedit"
          :class="!pedit ? '' : 'sa-d-none'"
        >
          <i class="icon-pencil sa-primary-text"></i>
        </button>
      </div>
    </div>
    <hr />
  </div>
</template>
<script>
import axios from "axios";
export default {
  props: ["editBoolean"],
  data() {
    return {
      unknownImg: "https://img.litedev.com/images/unknown-avtar.png",
      loader: false,
      file: "",
      fileName: "",
      pedit: false,
      clickFile: true,
      range: "",
    };
  },
  methods: {
    selectFile() {
      if (this.clickFile) {
        this.$refs.file.click();
      }
    },
    inputFile(newFile, oldFile, prevent) {
      if (
        newFile &&
        newFile.response &&
        newFile.response.data &&
        newFile.response.data[0] &&
        newFile.response.data[0] &&
        newFile.response.data[0].url
      ) {
      }
      if (newFile && !oldFile) {
        this.$nextTick(function () {
          this.edit = true;
        });
      }
      if (!newFile && oldFile) {
        this.edit = false;
      }
    },
    async onFileChange(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return;
      }
      this.loader = true;
      const formData = new FormData();
      formData.append("filename", files[0]);
      formData.append("data", { uploadtype: "profilepic" });
      let response = await axios.post(
        "https://imgpre.litedev.com/upload",
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );
      if (
        response &&
        response.data &&
        response.data.data &&
        response.data.data[0] &&
        response.data.data[0].url
      ) {
        this.$emit("imgEvent", response.data.data[0].url);
        this.loader = false;
      }
      this.fileName = files[0].name;
      this.createImage(files[0]);
      this.$parent.setImg(files[0].type);
    },
    createImage(file) {
      var image = new Image();
      var reader = new FileReader();

      reader.onload = (e) => {
        this.file = e.target.result;
        this.$emit("change", this.file);
      };
      reader.readAsDataURL(file);
    },
    removeFile() {
      this.file = "";
      this.fileName = "";
    },
  },
  watch: {
    editBoolean: {
      immediate: true,
      deep: true,
      handler() {
        this.clickFile = this.editBoolean;
      },
    },
    pedit: {
      immediate: true,
      handler() {
        let _self = this;
        _self.$emit("editFlag", _self.pedit);
      },
    },
    user: {
      immediate: true,
      handler() {
        let _self = this;
        if (_self.user) {
          _self.files = _self.user.img;
        }
      },
    },
  },
  computed: {
    user() {
      return this.$store.getters.getUobj;
    },
    MM: function () {
      let el = -51 - (51 / 100) * this.user.profile_complete;
      return el;
    },
  },
  created() {
    this.file = this.$store.getters.getUobj.img;
  },
};
</script>
